import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { IntakeOption, processForm, Tenant } from '@ee/common/models';


export function GenerateTenantForm(fb: UntypedFormBuilder, options: Map<string, IntakeOption>,
  skipValidators = false, tenant: Tenant | null = null): UntypedFormGroup {
  const form = fb.group({
    id: null,
    first_name: '',
    middle_name: '',
    last_name: '',
    ssn: '',
    email: '',
    dob: '',
    phone_number: '',
    is_not_active_military_member: null,
    scra_scan_status: null,
    scra_scan_date: null,
    active_duty_covered: null,
    active_duty_start_date: null,
    active_duty_end_date: null
  });

  if (tenant) {
    // clear scra and active duty fields
    form.patchValue({...tenant, scra_scan_status: null, scra_scan_date: null, active_duty_covered: null, active_duty_start_date: null, active_duty_end_date: null});
  }

  if (!skipValidators) {
    const additionalValidators: Map<string, ValidatorFn[]> = new Map<string, ValidatorFn[]>();
    additionalValidators.set('first_name', [Validators.required]); // override name validator (always require)
    additionalValidators.set('last_name', [Validators.required]); // override name validator (always require)

    if (options['is_not_active_military_member']?.required && options['is_not_active_military_member']?.show) {
      additionalValidators.set('is_not_active_military_member', [Validators.requiredTrue]);
    }

    // add validators per attorney's specifications
    return processForm(form, options, additionalValidators);
  }

  return form;
}
